<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-otp"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body text-center">
                    <div class="otp-title pb-2">{{lbl.otp.otp_code}}</div>
                    <div class="mt-3">{{lbl.otp.otp_phone}} {{ formatPhoneOtp(tel) }}</div>
                    <div class="mb-3">{{lbl.otp.refcode}} {{ refcode }}</div>
                    <div>
                        <label for="input-otp">
                            <div class="d-flex justify-content-center">
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[0]}}</div>
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[1]}}</div>
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[2]}}</div>
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[3]}}</div>
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[4]}}</div>
                                <div class="box-input-otp" :class="{'text-red' : isError}">{{otp[5]}}</div>
                            </div>
                        </label>
                    </div>
                    <input  type="tel"
                            id="input-otp"
                            class="input-otp-dummy"
                            maxlength="6"
                            v-model="otp"
                            @input="onOtpChange()">
                    <div v-if="isError" class="error">
                        {{ lbl.otp.err_otp }}
                        <div>{{ lbl.otp.err_code }} {{refcode}}</div>
                    </div>
                    <div v-if="!isExpireTime">
                        {{lbl.otp.time_remain}} <span class="text-red">{{timeHelper.displayTime}}</span>
                    </div>
                    <div v-else class="text-otp-time" @click="resendOtp()">{{lbl.otp.resend_otp}}</div>
                    <div class="d-flex justify-content-center mt-5">
                        <div class="mx-auto w-full px-1 pb-3">
                            <OutlineYellowButton @onClick="cancelOtp()">{{lbl.otp.btn_cancel}}</OutlineYellowButton>
                        </div>
                        <div class="mx-auto w-full px-1 pb-3">
                            <YellowButton @onClick="onSubmitOtp()" :isDisabled="isDisabledSubmit">{{lbl.otp.btn_ok}}</YellowButton>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper.js";
import Account from '@/helper/AccountHelper'
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
//component
import YellowButton from '@/components/Button/YellowButton.vue';
import OutlineYellowButton from '@/components/Button/OutlineYellowButton.vue';
/**
 * ! This file copy form Food Hunt
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",
    components:{
        YellowButton,
        OutlineYellowButton
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    mixins: [],
    data: function() {
        return {
            busModal: null,
            lbl: Locale.getLbl(),

            tel: '',
            otp: '',
            refcode: '',
            channel: '',
            isError: false,

            timeHelper: new TimerHelper(),
            isExpireTime: false,

            isRequestOtp: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timeHelper.initialTimer(60 * 3, null, false, false);
    },
    computed:{
        isDisabledSubmit: function(){
            if(this.otp.length == 6){
                return false
            }
            return true
        }
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
        this.busModal.$on('startOtp', this.startOtp);
        this.busModal.$on('cancelOtp', this.cancelOtp);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.tel = config.tel;
            this.refcode = config.refcode;
            this.isError = config.isError;
            this.showModal();
        },
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        //#region otp
        startOtp: async function(config) {
            this.isExpireTime = false;
            this.tel = config.tel;
            this.refcode = ''
            this.otp = '';
            this.isError = false;
            this.channel = config.channel;
            this.controller.loadingModal.show();
            this.success = false;
            if (this.channel == 'forget_password') {
                this.type = 'contact_number'
                this.success = await this.forgetPasswordOtp();
                if (this.success) {
                    this.controller.loadingModal.hide();
                    this.timeHelper.runTimer(() => {
                        this.setTimeout();
                    });

                    this.showModal();
                }
            } else {
                this.success = await this.apiRequestOtp();
                if (this.success) {
                    this.controller.loadingModal.hide();
                    this.timeHelper.runTimer(() => {
                        this.setTimeout();
                    });
                    this.showModal();
                }
            }
        },
        apiRequestOtp: async function() {
            if (this.isRequestOtp) return ;
            this.isRequestOtp = true;
            return new Promise((resolve) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe((data) => {
                    this.refcode = data.refcode;
                    resolve(true);
                }, (err) => {
                    console.log(err)
                    this.controller.loadingModal.hide();
                    if (err.id == 2128) {
                        this.controller.alertModal
                            .clearModal()
                            .setMsg("เบอร์โทรซ้ำ")
                            .show();
                        this.controller.alertModal.onClickOk(() => {
                            this.controller.sendCallbackError(err);
                        });
                    } else {
                        this.errorApi(err);
                    }

                    resolve(false);
                });
            });
        },

        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.hide();
            this.clearOtp();
            this.controller.sendCallbackCancel();
        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, '');
            this.isError = false;
        },

        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = true;
        },

        onSubmitOtp: async function() {
            if(this.isExpireTime || this.isDisabledSubmit) return;
            if (this.validateOtp()) {
                console.log('otp pass');
                var otpConfig = {
                    tel: this.tel,
                    otp: this.otp,
                    refcode: this.refcode,
                };
                // let success = await this.validateOtpApi();

                this.controller.sendCallbackSubmitOtp(otpConfig);
                // this.hide();
            }
        },
        validateOtp: function() {
            if (this.otp.length != 6) {
                var errorMsg = this.lbl.otp.otpLength;
                if (this.otp == '') {
                    errorMsg = this.lbl.otp.requireInput;
                }

                this.hide();
                this.controller.alertModal.clearModal()
                        .setMsg(errorMsg)
                        .show();
                this.controller.alertModal.onHidden(() => {
                    this.showModal();
                });
                return false;
            }

            return true;
        },
        validateOtpApi: function(){
            let token = Account.getToken();
            return new Promise((resolve) => {
                BzbsOtp.validateOtp(token, this.tel, this.refcode, this.otp, this.channel).subscribe((data) => {
                    console.log(data);
                    resolve(true);
                }, (err) => {
                    this.errorApi(err)
                    resolve(false);
                });
            });
        },
        resendOtp: async function() {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            this.isRequestOtp = false;
            // this.tel = config.tel;
            this.refcode = '';
            this.otp = '';

            await this.apiRequestOtp();

            this.controller.loadingModal.hide();
            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });

            // this.showModal();
        },
        clearOtp: function(){
            this.tel = '';
            this.refcode = '';
            this.otp = '';
            this.isRequestOtp = false;
        },
        //#endregion otp
        errorApi: function(err){
            this.controller.alertModal.setMsg(err.message).show();
        },
        formatPhoneOtp: function(tel){
            return Util.formatPhoneCountry(tel)
        },

        forgetPasswordOtp: function() {
            return new Promise((resolve) => {
                BzbsOtp.getforgetPasswordOtp(this.type, this.tel).subscribe((data) => {
                    this.refcode = data.refcode;
                    resolve(true);
                }, (err) => {
                    console.log(err)
                    this.controller.loadingModal.hide();
                    if (err.id == 404) {
                        err.message = this.lbl.forgetpassword.err_nodata;
                        this.errorApi(err);
                    } else {
                        this.errorApi(err);
                    }

                    resolve(false);
                });
            });
        },

    },
}
</script>
<style lang="scss">
    @import '@/style/base/base.scss';
    @import "@/style/modal.scss";
    @import "./OtpModal.scss";
    @import "../../../../style/base/baseUtility.scss";
    .error {
        color: #ff0000;
        padding-bottom: 20px;
        font-size: 14px;
    }
    .modal-base-body{
        font-size: 16px;
        font-family: 'PRT-Regular';
        color: $a-black-333333;
    }
    .text-red{
        color: #ff0000;
    }
    .modal-otp .modal-dialog .modal-content {
        border-radius: 20px;
    }
</style>



